import GoogleAdService from './google-ad-service'
import ApsBidderService from './aps-bidder-service'
import PrebidBidderService from './prebid-bidder-service'
import IntersectionLazyLoadObserverFactory from './intersection-lazy-load-observer'
import HeaderBiddingAdService from '../appl/header-bidding-ad-service'
import OpenXBidderService from './openx-bidder-service'
import BidderServiceManager from '../appl/bidder-service-manager'

export default class ServiceFactory {
    public static create(config: HeaderBiddingConfig) {
        const adService = new GoogleAdService(config)
        const bidderService = this.getBidderService(config, adService)
        const observerFactory = new IntersectionLazyLoadObserverFactory()
        return new HeaderBiddingAdService(adService, bidderService, config.slots, observerFactory)
    }

    private static getBidderService(config: HeaderBiddingConfig, adService: GoogleAdService) {
        const bidders = [] as BidderService[]
        if (config.apsConfig) bidders.push(new ApsBidderService(config))
        if (config.prebidConfig) bidders.push(new PrebidBidderService(config))
        if (config.slots.find(s => s.useOpenX === true)) {
            bidders.push(new OpenXBidderService(adService))
        }
        return new BidderServiceManager(config, bidders)
    }
}
